{
  "INBOX_MGMT": {
    "HEADER": "Zarządzanie skrzynkami",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Search inboxes...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "Your inbox is disconnected. You won't receive new messages until you reauthorize it.",
    "CLICK_TO_RECONNECT": "Click here to reconnect.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "Complete Registration",
    "LIST": {
      "404": "Nie ma żadnych skrzynek odbiorczych przypisanych do tego konta."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Wybierz kanał",
        "BODY": "Wybierz dostawcę, którego chcesz zintegrować z Chatwoot."
      },
      "INBOX": {
        "TITLE": "Utwórz skrzynkę odbiorczą",
        "BODY": "Uwierzytelnij swoje konto i utwórz skrzynkę odbiorczą."
      },
      "AGENT": {
        "TITLE": "Dodaj agentów",
        "BODY": "Dodaj agentów do utworzonej skrzynki odbiorczej."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Wszystko jest gotowe!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Nazwa skrzynki odbiorczej",
        "PLACEHOLDER": "Wprowadź nazwę skrzynki odbiorczej (np. Acme Inc).",
        "ERROR": "Wprowadź poprawną nazwę skrzynki odbiorczej"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nazwa strony",
        "PLACEHOLDER": "Wprowadź nazwę swojej witryny (np. Acme Inc.)."
      },
      "FB": {
        "HELP": "PS: Logując się, uzyskujemy dostęp tylko do wiadomości na Twojej stronie. Chatwoot nigdy nie będzie miał dostępu do prywatnych wiadomości.",
        "CHOOSE_PAGE": "Wybierz stronę",
        "CHOOSE_PLACEHOLDER": "Wybierz stronę z listy",
        "INBOX_NAME": "Nazwa skrzynki odbiorczej",
        "ADD_NAME": "Dodaj nazwę skrzynki odbiorczej",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Wybierz wartość",
        "CREATE_INBOX": "Utwórz skrzynkę odbiorczą"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continue with Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Connect your Instagram Profile",
        "HELP": "To add your Instagram profile as a channel, you need to authenticate your Instagram Profile by clicking on 'Continue with Instagram' ",
        "ERROR_MESSAGE": "There was an error connecting to Instagram, please try again",
        "ERROR_AUTH": "There was an error connecting to Instagram, please try again",
        "NEW_INBOX_SUGGESTION": "This Instagram account was previously linked to a different inbox and has now been migrated here. All new messages will appear here. The old inbox will no longer be able to send or receive messages for this account.",
        "DUPLICATE_INBOX_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. You won’t be able to send/receive Instagram messages from this inbox anymore.",
        "SETTINGS_RESTRICTED_WARNING": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
        "STATUS_LINK": "View status update"
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Continue with TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Connect your TikTok Profile",
        "HELP": "To add your TikTok profile as a channel, you need to authenticate your TikTok Profile by clicking on 'Continue with TikTok' ",
        "ERROR_MESSAGE": "There was an error connecting to TikTok, please try again",
        "ERROR_AUTH": "There was an error connecting to TikTok, please try again",
        "NORTH_AMERICA_WARNING": "TikTok connections for North American accounts are temporarily unavailable while we wait for an update from the TikTok team."
      },
      "TWITTER": {
        "HELP": "Aby dodać swój profil na Twitterze jako kanał, musisz uwierzytelnić swój profil Twittera, klikając „Zaloguj się przez Twitter”",
        "ERROR_MESSAGE": "Wystąpił błąd podczas łączenia z Twitterem. Spróbuj ponownie",
        "TWEETS": {
          "ENABLE": "Tworzenie konwersacji na podstawie wspomnianych tweetów"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Kanał strony internetowej",
        "DESC": "Utwórz kanał dla swojej strony internetowej i zacznij obsługiwać klientów za pomocą naszego widżetu na stronie.",
        "LOADING_MESSAGE": "Tworzenie kanału wsparcia dla strony internetowej",
        "CHANNEL_AVATAR": {
          "LABEL": "Awatar kanału"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL webhooka",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Wprowadź poprawny adres URL"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domena strony internetowej",
          "PLACEHOLDER": "Wprowadź domenę strony (np. acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Tytuł powitania",
          "PLACEHOLDER": "Cześć!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Tagline powitania",
          "PLACEHOLDER": "Łatwo się z nami skontaktujesz. Zadaj pytanie lub podziel się opinią."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Wiadomość powitalna kanału",
          "PLACEHOLDER": "Firma Acme Inc zazwyczaj odpowiada w ciągu kilku godzin."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Włącz powitanie dla kanału",
          "HELP_TEXT": "Automatycznie wysyłaj wiadomość powitalną, gdy utworzona zostanie nowa rozmowa.",
          "ENABLED": "Włączone",
          "DISABLED": "Wyłączone"
        },
        "REPLY_TIME": {
          "TITLE": "Ustaw czas odpowiedzi",
          "IN_A_FEW_MINUTES": "W ciągu kilku minut",
          "IN_A_FEW_HOURS": "W ciągu kilku godzin",
          "IN_A_DAY": "W ciągu dnia",
          "HELP_TEXT": "Czas odpowiedzi będzie wyświetlany w widżecie czatu na żywo."
        },
        "WIDGET_COLOR": {
          "LABEL": "Kolor widżetu",
          "PLACEHOLDER": "Zaktualizuj kolor widżetu używany w widżecie"
        },
        "SUBMIT_BUTTON": "Utwórz skrzynkę odbiorczą",
        "API": {
          "ERROR_MESSAGE": "Nie udało się utworzyć kanału dla strony internetowej. Spróbuj ponownie"
        }
      },
      "TWILIO": {
        "TITLE": "Kanał Twilio SMS/WhatsApp",
        "DESC": "Zintegruj Twilio i rozpocznij obsługę klientów za pomocą wiadomości SMS lub WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "ID konta",
          "PLACEHOLDER": "Wprowadź ID konta Twilio",
          "ERROR": "To pole jest wymagane"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "To pole jest wymagane"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "To pole jest wymagane"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "ID usługi wiadomości",
          "PLACEHOLDER": "Wprowadź ID usługi wiadomości Twilio",
          "ERROR": "To pole jest wymagane",
          "USE_MESSAGING_SERVICE": "Użyj usługi wiadomości Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Typ kanału",
          "ERROR": "Wybierz typ kanału"
        },
        "AUTH_TOKEN": {
          "LABEL": "Token uwierzytelniania",
          "PLACEHOLDER": "Wprowadź token uwierzytelniania Twilio",
          "ERROR": "To pole jest wymagane"
        },
        "CHANNEL_NAME": {
          "LABEL": "Nazwa skrzynki odbiorczej",
          "PLACEHOLDER": "Wprowadź nazwę skrzynki odbiorczej",
          "ERROR": "To pole jest wymagane"
        },
        "PHONE_NUMBER": {
          "LABEL": "Numer telefonu",
          "PLACEHOLDER": "Wprowadź numer telefonu, z którego będzie wysyłana wiadomość.",
          "ERROR": "Podaj poprawny numer telefonu, który zaczyna się od znaku „+” i nie zawiera spacji."
        },
        "API_CALLBACK": {
          "TITLE": "Adres URL zwrotny API",
          "SUBTITLE": "Musisz skonfigurować adres URL zwrotny wiadomości w Twilio z adresem URL podanym tutaj."
        },
        "SUBMIT_BUTTON": "Utwórz kanał Twilio",
        "API": {
          "ERROR_MESSAGE": "Nie udało się uwierzytelnić danych logowania Twilio. Spróbuj ponownie"
        }
      },
      "SMS": {
        "TITLE": "Kanał SMS",
        "DESC": "Rozpocznij obsługę klientów za pomocą wiadomości SMS.",
        "PROVIDERS": {
          "LABEL": "Dostawca API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Przepustowość"
        },
        "API": {
          "ERROR_MESSAGE": "Nie udało się zapisać kanału SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID konta",
            "PLACEHOLDER": "Wprowadź ID konta przepustowości",
            "ERROR": "To pole jest wymagane"
          },
          "API_KEY": {
            "LABEL": "Klucz API",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "To pole jest wymagane"
          },
          "API_SECRET": {
            "LABEL": "Sekret API",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "To pole jest wymagane"
          },
          "APPLICATION_ID": {
            "LABEL": "ID aplikacji",
            "PLACEHOLDER": "Wprowadź ID aplikacji przepustowości",
            "ERROR": "To pole jest wymagane"
          },
          "INBOX_NAME": {
            "LABEL": "Nazwa skrzynki odbiorczej",
            "PLACEHOLDER": "Wprowadź nazwę skrzynki odbiorczej",
            "ERROR": "To pole jest wymagane"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numer telefonu",
            "PLACEHOLDER": "Wprowadź numer telefonu, z którego będzie wysyłana wiadomość.",
            "ERROR": "Podaj poprawny numer telefonu, który zaczyna się od znaku „+” i nie zawiera spacji."
          },
          "SUBMIT_BUTTON": "Utwórz kanał SMS",
          "API": {
            "ERROR_MESSAGE": "Nie udało się uwierzytelnić poświadczeń przepustowości. Spróbuj ponownie"
          },
          "API_CALLBACK": {
            "TITLE": "Adres URL zwrotny API",
            "SUBTITLE": "Musisz skonfigurować adres URL zwrotny wiadomości w przepustowości z adresem URL podanym tutaj."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "Kanał WhatsApp",
        "DESC": "Rozpocznij obsługę klientów za pomocą wiadomości WhatsApp.",
        "PROVIDERS": {
          "LABEL": "Dostawca API",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "Chmura WhatsApp",
          "WHATSAPP_CLOUD_DESC": "Quick setup through Meta",
          "TWILIO_DESC": "Connect via Twilio credentials",
          "360_DIALOG": "360dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "Select your API provider",
          "DESCRIPTION": "Choose your WhatsApp provider. You can connect directly through Meta which requires no setup, or connect through Twilio using your account credentials."
        },
        "INBOX_NAME": {
          "LABEL": "Nazwa skrzynki odbiorczej",
          "PLACEHOLDER": "Wprowadź nazwę skrzynki odbiorczej",
          "ERROR": "To pole jest wymagane"
        },
        "PHONE_NUMBER": {
          "LABEL": "Numer telefonu",
          "PLACEHOLDER": "Wprowadź numer telefonu, z którego zostanie wysłana wiadomość.",
          "ERROR": "Podaj poprawny numer telefonu, który zaczyna się od znaku „+” i nie zawiera spacji."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "ID numeru telefonu",
          "PLACEHOLDER": "Wprowadź ID numeru telefonu uzyskane z panelu dewelopera Facebooka.",
          "ERROR": "Wprowadź poprawną wartość."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "ID konta firmowego",
          "PLACEHOLDER": "Wprowadź ID konta firmowego uzyskane z panelu dewelopera Facebooka.",
          "ERROR": "Wprowadź poprawną wartość."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Token weryfikujący Webhook",
          "PLACEHOLDER": "Enter a verify token which you want to configure for Facebook webhooks.",
          "ERROR": "Wprowadź poprawną wartość."
        },
        "API_KEY": {
          "LABEL": "Klucz API",
          "SUBTITLE": "Skonfiguruj klucz API WhatsApp.",
          "PLACEHOLDER": "Klucz API",
          "ERROR": "Wprowadź poprawną wartość."
        },
        "API_CALLBACK": {
          "TITLE": "Adres URL zwrotny API",
          "SUBTITLE": "Musisz skonfigurować adres URL webhooka i token weryfikacyjny w portalu dewelopera Facebooka z podanymi tutaj wartościami.",
          "WEBHOOK_URL": "Adres URL webhooka",
          "WEBHOOK_VERIFICATION_TOKEN": "Token weryfikacyjny webhooka"
        },
        "SUBMIT_BUTTON": "Utwórz kanał WhatsApp",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Quick setup with Meta",
          "DESC": "Use the WhatsApp Embedded Signup flow to quickly connect new numbers. You will be redirected to Meta to log into your WhatsApp Business account. Having admin access will help make the setup smooth and easy.",
          "BENEFITS": {
            "TITLE": "Benefits of Embedded Signup:",
            "EASY_SETUP": "No manual configuration required",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Automatic webhook and phone number configuration"
          },
          "LEARN_MORE": {
            "TEXT": "To learn more about integrated signup, pricing, and limitations, visit {link}.",
            "LINK_TEXT": "this link"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Authenticating with Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Setting up your WhatsApp Business Account",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Loading Facebook SDK...",
          "CANCELLED": "WhatsApp Signup was cancelled",
          "SUCCESS_TITLE": "WhatsApp Business Account Connected!",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Invalid business data received from Facebook. Please try again.",
          "SIGNUP_ERROR": "Signup error occurred",
          "AUTH_NOT_COMPLETED": "Authentication not completed. Please restart the process.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account has been successfully configured",
          "MANUAL_FALLBACK": "If your number is already connected to the WhatsApp Business Platform (API), or if you’re a tech provider onboarding your own number, please use the {link} flow",
          "MANUAL_LINK_TEXT": "manual setup flow",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "Nie udało się zapisać kanału WhatsApp"
        }
      },
      "VOICE": {
        "TITLE": "Voice Channel",
        "DESC": "Integrate Twilio Voice and start supporting your customers via phone calls.",
        "PHONE_NUMBER": {
          "LABEL": "Numer telefonu",
          "PLACEHOLDER": "Enter your phone number (e.g. +1234567890)",
          "ERROR": "Please provide a valid phone number in E.164 format (e.g. +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "ID konta",
            "PLACEHOLDER": "Enter your Twilio Account SID",
            "REQUIRED": "Account SID is required"
          },
          "AUTH_TOKEN": {
            "LABEL": "Token uwierzytelniania",
            "PLACEHOLDER": "Enter your Twilio Auth Token",
            "REQUIRED": "Auth Token is required"
          },
          "API_KEY_SID": {
            "LABEL": "API Key SID",
            "PLACEHOLDER": "Enter your Twilio API Key SID",
            "REQUIRED": "API Key SID is required"
          },
          "API_KEY_SECRET": {
            "LABEL": "API Key Secret",
            "PLACEHOLDER": "Enter your Twilio API Key Secret",
            "REQUIRED": "API Key Secret is required"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Configure this URL as the Voice URL on your Twilio phone number and TwiML App.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "Configure this URL as the Status Callback URL on your Twilio phone number."
        },
        "SUBMIT_BUTTON": "Create Voice Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the voice channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Kanał API",
        "DESC": "Zintegruj kanał API i rozpocznij obsługę klientów.",
        "CHANNEL_NAME": {
          "LABEL": "Nazwa kanału",
          "PLACEHOLDER": "Wprowadź nazwę kanału",
          "ERROR": "To pole jest wymagane"
        },
        "WEBHOOK_URL": {
          "LABEL": "Adres URL webhooka",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Adres URL webhooka"
        },
        "SUBMIT_BUTTON": "Utwórz kanał API",
        "API": {
          "ERROR_MESSAGE": "Nie udało się zapisać kanału API"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Kanał e-mail",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Nazwa kanału",
          "PLACEHOLDER": "Wprowadź nazwę kanału",
          "ERROR": "To pole jest wymagane"
        },
        "EMAIL": {
          "LABEL": "E-mail",
          "SUBTITLE": "Adres e-mail, na który klienci wysyłają zgłoszenia",
          "PLACEHOLDER": "E-mail"
        },
        "SUBMIT_BUTTON": "Utwórz kanał e-mail",
        "API": {
          "ERROR_MESSAGE": "Nie udało nam się zapisać kanału e-mail"
        },
        "FINISH_MESSAGE": "Zacznij przekierowywać wiadomości na poniższy adres e-mail.",
        "FINISH_MESSAGE_NO_FORWARDING": "Your email inbox has been created successfully! You need to configure SMTP and IMAP credentials to send and receive emails. Without these settings, no emails will be processed.",
        "FORWARDING_ADDRESS_LABEL": "Forward emails to this address:",
        "CONFIGURE_SMTP_IMAP_LINK": "Kliknij tutaj",
        "CONFIGURE_SMTP_IMAP_TEXT": " to configure IMAP and SMTP settings"
      },
      "LINE_CHANNEL": {
        "TITLE": "Kanał LINE",
        "DESC": "Zintegruj kanał LINE i rozpocznij obsługę klientów.",
        "CHANNEL_NAME": {
          "LABEL": "Nazwa kanału",
          "PLACEHOLDER": "Wprowadź nazwę kanału",
          "ERROR": "To pole jest wymagane"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID kanału LINE",
          "PLACEHOLDER": "ID kanału LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Sekret kanału LINE",
          "PLACEHOLDER": "Sekret kanału LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token kanału LINE",
          "PLACEHOLDER": "Token kanału LINE"
        },
        "SUBMIT_BUTTON": "Utwórz kanał LINE",
        "API": {
          "ERROR_MESSAGE": "Nie udało się zapisać kanału LINE"
        },
        "API_CALLBACK": {
          "TITLE": "Adres URL zwrotny API",
          "SUBTITLE": "Musisz skonfigurować adres URL webhooka w aplikacji LINE z podanym tutaj adresem URL."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Kanał Telegram",
        "DESC": "Zintegruj kanał Telegram i rozpocznij obsługę klientów.",
        "BOT_TOKEN": {
          "LABEL": "Token bota",
          "SUBTITLE": "Skonfiguruj token bota, który otrzymałeś od Telegram BotFather.",
          "PLACEHOLDER": "Token bota"
        },
        "SUBMIT_BUTTON": "Utwórz kanał Telegram",
        "API": {
          "ERROR_MESSAGE": "Nie udało się zapisać kanału Telegram"
        }
      },
      "AUTH": {
        "TITLE": "Wybierz kanał",
        "DESC": "Chatwoot supports live-chat widgets, Facebook Messenger, Twitter profiles, WhatsApp, Emails, etc., as channels. If you want to build a custom channel, you can create it using the API channel. To get started, choose one of the channels below.",
        "TITLE_NEXT": "Complete the setup",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "Website",
            "DESCRIPTION": "Create a live-chat widget"
          },
          "FACEBOOK": {
            "TITLE": "Facebook",
            "DESCRIPTION": "Connect your Facebook page"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "Support your customers on WhatsApp"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "E-mail",
            "DESCRIPTION": "Connect with Gmail, Outlook, or other providers"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Integrate SMS channel with Twilio or bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "Make a custom channel using our API"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "Configure Telegram channel using Bot token"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Integrate your Line channel"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Connect your instagram account"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Connect your TikTok account"
          },
          "VOICE": {
            "TITLE": "Voice",
            "DESCRIPTION": "Integrate with Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "Agenci",
        "DESC": "Tutaj możesz dodać agentów do zarządzania swoją nowo utworzoną skrzynką odbiorczą. Tylko ci wybrani agenci będą mieli dostęp do Twojej skrzynki odbiorczej. Agenci, którzy nie są częścią tej skrzynki odbiorczej nie będą mogli zobaczyć ani odpowiadać na wiadomości w tej skrzynce odbiorczej podczas logowania. <br> <b>PS:</b> Jako administrator, jeśli potrzebujesz dostępu do wszystkich skrzynek odbiorczych, powinieneś dodać siebie jako agenta do wszystkich skrzynek odbiorczych, które tworzysz.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Wybierz agentów dla skrzynki odbiorczej"
      },
      "DETAILS": {
        "TITLE": "Skonfiguruj szczegóły skrzynki odbiorczej",
        "DESC": "Z listy rozwijanej poniżej wybierz stronę na Facebooku, którą chcesz połączyć z czatwootem. Możesz również podać własną nazwę swojej skrzynki odbiorczej w celu lepszej identyfikacji."
      },
      "FINISH": {
        "TITLE": "Twoja skrzynka odbiorcza jest gotowa!",
        "DESC": "Pomyślnie zakończyłeś integrację strony na Facebooku z czatwootem. Następnym razem, gdy klient komunikuje Twoją stronę, konwersacja pojawi się automatycznie na twojej skrzynce odbiorczej.<br>Dostarczamy również skrypt widżetu, który można łatwo dodać do swojej witryny. Gdy tylko będzie on dostępny na Twojej stronie internetowej, klienci mogą wysyłać Ci wiadomości bezpośrednio z Twojej strony bez pomocy żadnego zewnętrznego narzędzia, a konwersacja pojawi się tutaj w Chatwoot.<br>Coś, co? Cóż, na pewno spróbujemy być :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Wybierz dostawcę poczty e-mail",
        "DESCRIPTION": "Wybierz dostawcę poczty e-mail z poniższej listy. Jeśli nie widzisz swojego dostawcy poczty e-mail na liście, możesz wybrać opcję innego dostawcy i podać poświadczenia IMAP i SMTP."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Kliknij przycisk Zaloguj się za pomocą Microsoft, aby rozpocząć. Nastąpi przekierowanie do strony logowania przez e-mail. Po zaakceptowaniu wymaganych uprawnień zostaniesz przekierowany z powrotem do etapu tworzenia skrzynki odbiorczej.",
        "EMAIL_PLACEHOLDER": "Wprowadź adres e-mail",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "Wystąpił błąd połączenia z Microsoft, spróbuj ponownie"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Wprowadź adres e-mail",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Uwierzytelnianie za pomocą Facebooka...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Coś poszło nie tak. Proszę odświeżyć stronę...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "CREATING_CHANNEL": "Tworzenie skrzynki odbiorczej...",
      "TITLE": "Skonfiguruj szczegóły skrzynki odbiorczej",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Dodaj agentów",
      "ADD_AGENTS": "Dodawanie agentów do skrzynki odbiorczej..."
    },
    "FINISH": {
      "TITLE": "Twoja skrzynka odbiorcza jest gotowa!",
      "MESSAGE": "Możesz teraz kontaktować się z klientami za pośrednictwem nowego kanału. Szczęśliwy wspierający",
      "BUTTON_TEXT": "Zabierz mnie tam",
      "MORE_SETTINGS": "Więcej ustawień",
      "WEBSITE_SUCCESS": "Pomyślnie zakończyłeś tworzenie kanału internetowego. Skopiuj poniższy kod i wklej go na swojej stronie. Następnym razem, gdy klient korzysta z czatu na żywo, konwersacja pojawi się automatycznie na twojej skrzynce odbiorczej.",
      "WHATSAPP_QR_INSTRUCTION": "Scan the QR code above to quickly test your WhatsApp inbox",
      "MESSENGER_QR_INSTRUCTION": "Scan the QR code above to quickly test your Facebook Messenger inbox",
      "TELEGRAM_QR_INSTRUCTION": "Scan the QR code above to quickly test your Telegram inbox"
    },
    "REAUTH": "Ponowna autoryzacja",
    "VIEW": "Widok",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Ustawienia skrzynki odbiorczej zostały zaktualizowane",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatyczne przypisanie zaktualizowane pomyślnie",
        "ERROR_MESSAGE": "Nie mogliśmy zaktualizować ustawień skrzynki odbiorczej. Spróbuj ponownie później."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Włączone",
        "DISABLED": "Wyłączone"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Włączone",
        "DISABLED": "Wyłączone"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Przyjazna",
          "FROM": "od",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesjonalna",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Zapisz"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Włączone",
        "DISABLED": "Wyłączone"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Włączone",
        "DISABLED": "Wyłączone"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "Włącz"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Usuń",
      "AVATAR_DELETE_BUTTON_TEXT": "Usuń awatar",
      "CONFIRM": {
        "TITLE": "Potwierdź usunięcie",
        "MESSAGE": "Czy na pewno chcesz usunąć ",
        "PLACE_HOLDER": "Wpisz {inboxName}, aby potwierdzić",
        "YES": "Tak, usuń ",
        "NO": "Nie, zachowaj "
      },
      "API": {
        "SUCCESS_MESSAGE": "Skrzynka odbiorcza została usunięta",
        "ERROR_MESSAGE": "Nie można usunąć skrzynki odbiorczej. Spróbuj ponownie później.",
        "AVATAR_SUCCESS_MESSAGE": "Pomyślnie usunięto awatar skrzynki odbiorczej",
        "AVATAR_ERROR_MESSAGE": "Nie można usunąć awatara skrzynki odbiorczej. Spróbuj ponownie później."
      }
    },
    "TABS": {
      "SETTINGS": "Ustawienia",
      "COLLABORATORS": "Współpracownicy",
      "CONFIGURATION": "Konfiguracja",
      "CAMPAIGN": "Kampania",
      "PRE_CHAT_FORM": "Formularz czatu wstępnego",
      "BUSINESS_HOURS": "Godziny pracy",
      "WIDGET_BUILDER": "Kreator widżetów",
      "BOT_CONFIGURATION": "Konfiguracja bota",
      "ACCOUNT_HEALTH": "Account Health",
      "CSAT": "CSAT",
      "VOICE": "Voice",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      },
      "INBOUND": {
        "LABEL": "Allow incoming calls",
        "DESCRIPTION": "Let customers call this number. When turned off, incoming calls are declined automatically — agents aren't notified and no conversation is created. Agents can still place outgoing calls."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "Manage your WhatsApp account",
      "DESCRIPTION": "Review your WhatsApp account status, messaging limits, and quality. Update settings or resolve issues if needed",
      "GO_TO_SETTINGS": "Go to Meta Business Manager",
      "NO_DATA": "Health data is not available",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Display phone number",
          "TOOLTIP": "Phone number displayed to customers"
        },
        "VERIFIED_NAME": {
          "LABEL": "Business name",
          "TOOLTIP": "Business name verified by WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Display name status",
          "TOOLTIP": "Status of your business name verification"
        },
        "QUALITY_RATING": {
          "LABEL": "Quality rating",
          "TOOLTIP": "WhatsApp quality rating for your account"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Messaging limit tier",
          "TOOLTIP": "Daily messaging limit for your account"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Account mode",
          "TOOLTIP": "Current operating mode of your WhatsApp account"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 customers per 24h",
          "TIER_1000": "1K customers per 24h",
          "TIER_1K": "1K customers per 24h",
          "TIER_10K": "10K customers per 24h",
          "TIER_100K": "100K customers per 24h",
          "TIER_UNLIMITED": "Unlimited customers per 24h",
          "UNKNOWN": "Rating not available"
        },
        "STATUSES": {
          "APPROVED": "Approved",
          "PENDING_REVIEW": "Pending Review",
          "AVAILABLE_WITHOUT_REVIEW": "Available Without Review",
          "REJECTED": "Rejected",
          "DECLINED": "Declined",
          "NON_EXISTS": "Non exists"
        },
        "MODES": {
          "SANDBOX": "Sandbox",
          "LIVE": "Na żywo"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "Ustawienia",
    "FEATURES": {
      "LABEL": "Funkcje",
      "DISPLAY_FILE_PICKER": "Wyświetl selektor plików w widżecie",
      "DISPLAY_EMOJI_PICKER": "Wyświetl selektor emoji w widżecie",
      "ALLOW_END_CONVERSATION": "Umożliwienie użytkownikom zakończenia konwersacji z poziomu widżetu",
      "USE_INBOX_AVATAR_FOR_BOT": "Użyj nazwy skrzynki odbiorczej i awatara dla bota"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Skrypt Messengera",
      "MESSENGER_SUB_HEAD": "Umieść ten przycisk wewnątrz znacznika ciała",
      "ALLOWED_DOMAINS": {
        "TITLE": "Allowed Domains",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "Secret Key",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "Agenci",
      "INBOX_AGENTS_SUB_TEXT": "Dodaj lub usuń agentów z tej skrzynki odbiorczej",
      "AGENT_ASSIGNMENT": "Zadanie konwersacji",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Aktualizacja ustawień przypisywania konwersacji",
      "UPDATE": "Aktualizuj",
      "ENABLE_EMAIL_COLLECT_BOX": "Włącz skrzynkę odbiorczą e-mail",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Włącz lub wyłącz skrzynkę zbierania wiadomości e-mail w nowej konwersacji",
      "AUTO_ASSIGNMENT": "Włącz automatyczne przypisanie",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Włącz ciągłość rozmowy przez e-mail",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Rozmowy będą kontynuowane przez e-mail, jeśli adres e-mail kontaktu jest dostępny.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "Ustawienia skrzynki odbiorczej",
      "INBOX_UPDATE_SUB_TEXT": "Zaktualizuj ustawienia skrzynki odbiorczej",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Włącz lub wyłącz automatyczne przypisywanie nowych rozmów do agentów dodanych do tej skrzynki odbiorczej.",
      "HMAC_VERIFICATION": "Weryfikacja tożsamości użytkownika",
      "HMAC_DESCRIPTION": "In order to validate the user's identity, you can pass an `identifier_hash` for each user. You can generate a HMAC sha256 hash using the `identifier` with the key shown here.",
      "HMAC_LINK_TO_DOCS": "Więcej informacji można znaleźć tutaj.",
      "HMAC_MANDATORY_VERIFICATION": "Wymuś sprawdzanie tożsamości użytkownika",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "INBOX_IDENTIFIER": "Identyfikator skrzynki odbiorczej",
      "INBOX_IDENTIFIER_SUB_TEXT": "Użyj tokenu `inbox_identifier` pokazanego tutaj, aby uwierzytelnić swoich klientów API.",
      "FORWARD_EMAIL_TITLE": "Przekaż do wiadomości e-mail",
      "FORWARD_EMAIL_SUB_TEXT": "Zacznij przekierowywać swoje wiadomości na następujący adres e-mail.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Forwarding emails to your inbox is currently disabled on this installation. To use this feature, it must be enabled by your administrator. Please get in touch with them to proceed.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Zezwalaj na wiadomości po rozwiązaniu konwersacji",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Zezwalaj użytkownikom końcowym na wysyłanie wiadomości nawet po zakończeniu konwersacji.",
      "WHATSAPP_SECTION_SUBHEADER": "Ten klucz API jest używany do integracji z interfejsami API WhatsApp.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Enter the new API key to be used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_TITLE": "Klucz API",
      "WHATSAPP_SECTION_UPDATE_TITLE": "Aktualizacja klucza API",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Wprowadź nowy klucz API tutaj",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "Aktualizuj",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "This inbox is connected through WhatsApp embedded signup.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "You can reconfigure this inbox to update your WhatsApp Business settings.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Reconfigure",
      "WHATSAPP_MANUAL_TRANSFER_TITLE": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUBHEADER": "This inbox was connected through WhatsApp embedded signup, which is no longer supported. Enter the WhatsApp Cloud API credentials from your own Meta app to switch this inbox to a manual setup. Configure the webhook in your Meta app using the verification token above before switching.",
      "WHATSAPP_MANUAL_TRANSFER_PHONE_NUMBER_ID_LABEL": "Phone Number ID",
      "WHATSAPP_MANUAL_TRANSFER_BUSINESS_ACCOUNT_ID_LABEL": "ID konta firmowego",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_LABEL": "Klucz API",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_PLACEHOLDER": "Enter a permanent access token from your Meta app",
      "WHATSAPP_MANUAL_TRANSFER_BUTTON": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUCCESS": "Inbox switched to manual setup successfully.",
      "WHATSAPP_MANUAL_TRANSFER_ERROR": "Could not switch to manual setup. Please verify the credentials and try again.",
      "WHATSAPP_CONNECT_TITLE": "Connect to WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "Upgrade to WhatsApp embedded signup for easier management.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Connect this inbox to WhatsApp Business for enhanced features and easier management.",
      "WHATSAPP_CONNECT_BUTTON": "Połącz",
      "WHATSAPP_CONNECT_SUCCESS": "Successfully connected to WhatsApp Business!",
      "WHATSAPP_CONNECT_ERROR": "Failed to connect to WhatsApp Business. Please try again.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "Successfully reconfigured WhatsApp Business!",
      "WHATSAPP_RECONFIGURE_ERROR": "Failed to reconfigure WhatsApp Business. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp login was cancelled. Please try again.",
      "WHATSAPP_WEBHOOK_TITLE": "Token weryfikacyjny webhooka",
      "WHATSAPP_WEBHOOK_SUBHEADER": "Ten token służy do weryfikacji autentyczności punktu końcowego webhooka.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "Manually sync message templates from WhatsApp to update your available templates.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Templates sync initiated successfully. It may take a couple of minutes to update.",
      "WHATSAPP_MANUAL_MIGRATION": {
        "BANNER": {
          "TITLE": "Manual setup recommended",
          "DESCRIPTION": "This inbox connects through the shared Meta app used for embedded signup, which recent Meta restrictions have affected. To avoid similar issues in the future, we recommend reconnecting it with your own Meta app.",
          "START": "Start manual migration",
          "GUIDE": "View guide"
        },
        "DIALOG": {
          "EYEBROW": "WhatsApp manual migration",
          "TITLE": "Reconnect WhatsApp inbox",
          "CLOSE": "Zamknij",
          "ACTION_REQUIRED_TITLE": "Reconnect with your own Meta app",
          "ACTION_REQUIRED_DESCRIPTION": "Inboxes connected through your own Meta app are not affected by restrictions on the shared embedded signup app. This guided flow updates the WhatsApp API connection without creating a new inbox.",
          "GUIDE_LINK": "Open the manual setup guide",
          "PRESERVED_TITLE": "Preserved",
          "PRESERVED_DESCRIPTION": "Conversations, contacts, collaborators, routing, business hours, and inbox settings.",
          "UPDATED_TITLE": "Updated",
          "UPDATED_DESCRIPTION": "WABA ID, phone number ID, access token, and webhook configuration.",
          "WABA_ID": "WABA ID",
          "WABA_PLACEHOLDER": "Enter WABA ID",
          "WABA_HELP": "The WhatsApp Business Account that owns this phone number.",
          "PHONE_NUMBER_ID": "Phone Number ID",
          "PHONE_NUMBER_PLACEHOLDER": "Enter Phone Number ID",
          "PHONE_NUMBER_HELP": "Meta's unique ID for the WhatsApp number connected to this inbox.",
          "DISPLAY_PHONE_NUMBER": "Display phone number",
          "DISPLAY_PHONE_NUMBER_PLACEHOLDER": "Enter display phone number",
          "DISPLAY_PHONE_NUMBER_HELP": "The customer-facing WhatsApp number. This cannot be changed during migration.",
          "ACCESS_TOKEN": "Permanent access token or system user token",
          "ACCESS_TOKEN_PLACEHOLDER": "Paste access token",
          "TOKEN_HELP_PREFIX": "The token must include",
          "TOKEN_HELP_MIDDLE": "Dodaj",
          "TOKEN_HELP_SUFFIX": "for template sync and template management.",
          "MESSAGING_PERMISSION": "whatsapp_business_messaging.",
          "MANAGEMENT_PERMISSION": "whatsapp_business_management",
          "REVIEW_TITLE": "Review before reconnecting",
          "INBOX": "Skrzynka odbiorcza",
          "PHONE_NUMBER": "Numer telefonu",
          "NOT_ENTERED": "Not entered",
          "VERIFY_NOTICE": "Chatwoot will verify these credentials with Meta before applying any changes. If verification fails, the current configuration is left untouched.",
          "BACK": "Powrót",
          "CANCEL": "Anuluj",
          "CONTINUE": "Continue",
          "REVIEW_MIGRATION": "Review migration",
          "RECONNECT": "Reconnect WhatsApp inbox"
        },
        "STEPS": {
          "BEFORE_YOU_START": {
            "TITLE": "Before you start",
            "DESCRIPTION": "This reconnects the WhatsApp API details for this inbox. Conversations, collaborators, routing, business hours, CSAT, and bot settings will be preserved."
          },
          "BUSINESS_DETAILS": {
            "TITLE": "Business details",
            "DESCRIPTION": "Enter the WhatsApp assets from the customer Meta Business account."
          },
          "ACCESS_TOKEN": {
            "TITLE": "Access token",
            "DESCRIPTION": "Paste a permanent access token or system user token with WhatsApp permissions."
          },
          "REVIEW_MIGRATION": {
            "TITLE": "Review migration",
            "DESCRIPTION": "Confirm the connection details before reconnecting this inbox. Chatwoot will verify the token, WABA, and phone number with Meta before applying changes."
          }
        }
      },
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Aktualizacja ustawień formularza czatu wstępnego"
    },
    "HELP_CENTER": {
      "LABEL": "Centrum pomocy",
      "PLACEHOLDER": "Wybierz Centrum pomocy",
      "SELECT_PLACEHOLDER": "Wybierz Centrum pomocy",
      "NONE": "Brak",
      "REMOVE": "Usuń Centrum pomocy",
      "SUB_TEXT": "Dołącz Centrum pomocy do skrzynki odbiorczej"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Limit automatycznego przypisywania",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Wprowadź wartość większą niż 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Ogranicz maksymalną liczbę wątków z tej skrzynki odbiorczej, które mogą zostać automatycznie przypisane do agenta"
    },
    "ASSIGNMENT": {
      "TITLE": "Zadanie konwersacji",
      "DESCRIPTION": "Automatically assign incoming conversations to available agents based on assignment policies",
      "ENABLE_AUTO_ASSIGNMENT": "Enable automatic conversation assignment",
      "DEFAULT_RULES_TITLE": "Default assignment rules",
      "DEFAULT_RULES_DESCRIPTION": "Using the default assignment behavior for all conversations",
      "DEFAULT_RULE_1": "Earliest created conversations first",
      "DEFAULT_RULE_2": "Round robin distribution",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Using custom assignment policy for this inbox",
      "CUSTOMIZE_POLICY": "Customize with assignment policy",
      "DELETE_POLICY": "Delete policy",
      "POLICY_LABEL": "Assignment policy",
      "ASSIGNMENT_ORDER_LABEL": "Assignment Order",
      "ASSIGNMENT_METHOD_LABEL": "Assignment Method",
      "POLICY_STATUS": {
        "ACTIVE": "Aktywne",
        "INACTIVE": "Inactive"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "Earliest created",
        "LONGEST_WAITING": "Longest waiting"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin",
        "BALANCED": "Balanced assignment"
      },
      "UPGRADE_PROMPT": "Custom assignment policies are available on the Business plan",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Default policy linked",
      "DEFAULT_POLICY_DESCRIPTION": "Link a custom assignment policy to customize how conversations are assigned to agents in this inbox.",
      "LINK_EXISTING_POLICY": "Link existing policy",
      "CREATE_NEW_POLICY": "Create new policy",
      "NO_POLICIES": "No assignment policies found",
      "VIEW_ALL_POLICIES": "View all policies",
      "CURRENT_BEHAVIOR": "Currently using default assignment behavior:",
      "LINK_SUCCESS": "Assignment policy linked successfully",
      "LINK_ERROR": "Failed to link assignment policy"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Delete assignment policy?",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to remove this assignment policy from this inbox? The inbox will revert to default assignment rules.",
      "CANCEL": "Anuluj",
      "CONFIRM_DELETE": "Usuń",
      "DELETE_SUCCESS": "Assignment policy removed successfully",
      "DELETE_ERROR": "Failed to remove assignment policy"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Ponowna autoryzacja",
      "SUBTITLE": "Twoje połączenie z Facebookiem wygasło, połącz się z nim ponownie, aby kontynuować świadczenie usług",
      "MESSAGE_SUCCESS": "Ponowne połączenie powiodło się",
      "MESSAGE_ERROR": "Wystąpił błąd, spróbuj ponownie"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Formularze czatu umożliwiają przechwytywanie informacji o użytkowniku przed rozpoczęciem rozmowy z Tobą.",
      "SET_FIELDS": "Pola formularza czatu wstępnego",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Pola",
        "LABEL": "Etykieta",
        "PLACE_HOLDER": "Etykieta zastępcza",
        "KEY": "Klucz",
        "TYPE": "Typ",
        "REQUIRED": "Wymagane"
      },
      "ENABLE": {
        "LABEL": "Włącz formularz przed czatem",
        "OPTIONS": {
          "ENABLED": "Tak",
          "DISABLED": "Nie"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Wiadomość czatu wstępnego",
        "PLACEHOLDER": "Ta wiadomość będzie widoczna dla użytkowników wraz z formularzem"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Odwiedzający powinni podać swoje imię i nazwisko oraz adres e-mail przed rozpoczęciem czatu"
      }
    },
    "CSAT": {
      "TITLE": "Włącz CSAT",
      "SUBTITLE": "Automatically trigger CSAT surveys at the end of conversations to understand how customers feel about their support experience. Track satisfaction trends and identify areas for improvement over time.",
      "DISPLAY_TYPE": {
        "LABEL": "Display type"
      },
      "MESSAGE": {
        "LABEL": "Wiadomość",
        "PLACEHOLDER": "Please enter a message to show users with the form"
      },
      "BUTTON_TEXT": {
        "LABEL": "Button text",
        "PLACEHOLDER": "Please rate us"
      },
      "LANGUAGE": {
        "LABEL": "Język",
        "PLACEHOLDER": "Select template language"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Message preview",
        "TOOLTIP": "This may vary slightly when rendered on WhatsApp's platform."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "Approved by WhatsApp",
        "PENDING": "Pending WhatsApp approval",
        "REJECTED": "Meta rejected the template",
        "DEFAULT": "Needs WhatsApp approval",
        "NOT_FOUND": "The template does not exist in the Meta platform."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp template created successfully and sent for approval",
        "ERROR_MESSAGE": "Failed to create WhatsApp template"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Edit survey details",
        "DESCRIPTION": "We will delete the previous template and make a new one which will be sent again for WhatsApp approval",
        "CONFIRM": "Create new template",
        "CANCEL": "Powróć"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Survey rule",
        "DESCRIPTION_PREFIX": "Send the survey if the conversation",
        "DESCRIPTION_SUFFIX": "any of the labels",
        "OPERATOR": {
          "CONTAINS": "zawiera",
          "DOES_NOT_CONTAINS": "nie zawiera"
        },
        "SELECT_PLACEHOLDER": "select labels"
      },
      "NOTE": "Note: CSAT surveys are sent only once per conversation",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT settings updated successfully",
        "ERROR_MESSAGE": "We couldn't update CSAT settings. Please try again later."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Ustaw swoją dostępność",
      "SUBTITLE": "Ustaw swoją dostępność na widżecie na czacie",
      "WEEKLY_TITLE": "Ustaw swoje godziny tygodniowe",
      "TIMEZONE_LABEL": "Wybierz strefę czasową",
      "UPDATE": "Zaktualizuj ustawienia godzin pracy",
      "TOGGLE_AVAILABILITY": "Włącz dostępność biznesową dla tej skrzynki odbiorczej",
      "UNAVAILABLE_MESSAGE_LABEL": "Wiadomość niedostępna dla odwiedzających",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "DAY": "Dzień",
        "AVAILABILITY": "Dostępność",
        "HOURS": "Hours",
        "ENABLE": "Włącz dostępność w tym dniu",
        "UNAVAILABLE": "Niedostępny",
        "VALIDATION_ERROR": "Czas rozpoczęcia powinien być przed czasem zakończenia.",
        "CHOOSE": "Wybierz"
      },
      "ALL_DAY": "Cały dzień"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Ustaw szczegóły IMAP",
      "NOTE_TEXT": "Aby włączyć SMTP, należy skonfigurować IMAP.",
      "UPDATE": "Aktualizuj ustawienia IMAP",
      "TOGGLE_AVAILABILITY": "Włącz konfigurację IMAP dla tej skrzynki odbiorczej",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Ustawienia IMAP zostały zaktualizowane",
        "ERROR_MESSAGE": "Nie można zaktualizować ustawień IMAP"
      },
      "ADDRESS": {
        "LABEL": "Adres IP",
        "PLACE_HOLDER": "Adres (Eg: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Zaloguj się",
        "PLACE_HOLDER": "Zaloguj się"
      },
      "PASSWORD": {
        "LABEL": "Hasło",
        "PLACE_HOLDER": "Hasło"
      },
      "ENABLE_SSL": "Włącz SSL",
      "AUTH_MECHANISM": "Uwierzytelnianie"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Ponowna autoryzacja konta MICROSOFT"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Ustaw szczegóły SMTP",
      "UPDATE": "Aktualizuj ustawienia SMTP",
      "TOGGLE_AVAILABILITY": "Włącz konfigurację SMTP dla tej skrzynki odbiorczej",
      "TOGGLE_HELP": "Włączenie SMTP pomoże użytkownikowi wysyłać wiadomości e-mail",
      "EDIT": {
        "SUCCESS_MESSAGE": "Ustawienia SMTP zostały pomyślnie zaktualizowane",
        "ERROR_MESSAGE": "Nie można zaktualizować ustawień SMTP"
      },
      "ADDRESS": {
        "LABEL": "Adres IP",
        "PLACE_HOLDER": "Adres (np. smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Zaloguj się",
        "PLACE_HOLDER": "Zaloguj się"
      },
      "PASSWORD": {
        "LABEL": "Hasło",
        "PLACE_HOLDER": "Hasło"
      },
      "DOMAIN": {
        "LABEL": "Domena",
        "PLACE_HOLDER": "Domena"
      },
      "ENCRYPTION": "Szyfrowanie",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Otwórz tryb weryfikacji SSL",
      "AUTH_MECHANISM": "Uwierzytelnianie"
    },
    "NOTE": "Uwaga: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Awatar strony internetowej",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Awatar został pomyślnie usunięty",
              "ERROR_MESSAGE": "Wystąpił błąd, spróbuj ponownie"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nazwa strony",
          "PLACE_HOLDER": "Wprowadź nazwę swojej strony (np. Acme Inc)",
          "ERROR": "Wprowadź poprawną nazwę witryny"
        },
        "WELCOME_HEADING": {
          "LABEL": "Nagłówek powitalny",
          "PLACE_HOLDER": "Cześć!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Tagline powitalny",
          "PLACE_HOLDER": "Łatwo się z nami połączyć. Zapytaj nas o coś lub podziel się swoją opinią."
        },
        "REPLY_TIME": {
          "LABEL": "Czas odpowiedzi",
          "IN_A_FEW_MINUTES": "W ciągu kilku minut",
          "IN_A_FEW_HOURS": "W ciągu kilku godzin",
          "IN_A_DAY": "W ciągu dnia"
        },
        "WIDGET_COLOR_LABEL": "Kolor widżetu",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "Typ:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Porozmawiaj z nami",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "Porozmawiaj z nami"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Aktualizacja ustawień widżetu",
          "API": {
            "SUCCESS_MESSAGE": "Ustawienia widżetu zostały pomyślnie zaktualizowane",
            "ERROR_MESSAGE": "Nie można zaktualizować ustawień widżetu"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Podgląd",
          "SCRIPT": "Skrypt"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Lewo",
          "RIGHT": "Prawo"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Rozszerzony bąbelek"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Domyślny",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Zwykle odpowiadamy w ciągu paru minut",
        "IN_A_FEW_HOURS": "Zwykle odpowiadamy w ciągu paru godzin",
        "IN_A_DAY": "Zwykle odpowiadamy w przeciągu jednego dnia"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Rozpocznij rozmowę",
        "CHAT_INPUT_PLACEHOLDER": "Wpisz treść wiadomości"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Jesteśmy online",
          "OFFLINE": "W tej chwili jesteśmy niedostępni"
        },
        "USER_MESSAGE": "Cześć",
        "AGENT_MESSAGE": "Witam"
      },
      "BRANDING_TEXT": "Napędzany przez Chatwoot",
      "SCRIPT_SETTINGS": "\n      window.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Connect with Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Connect with Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Inni dostawcy",
        "DESCRIPTION": "Connect with Other Providers"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Website",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "E-mail",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Kanał API",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Voice"
    }
  }
}
